// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"ProcessSteps--next-sr-only--3F62XKG","cardTitle":"ProcessSteps--cardTitle--1ck1ohg","stepButton":"ProcessSteps--stepButton--3lHJBca"};